export const YCN_LOGO_URL = "/brand/ycn-logo.png";

export const YCN_FOUNDERS_IMAGE = "/brand/ycn-founders.jpg";
export const ASHLEY_PORTRAIT = "/brand/ashley-marie-lewis.jpg";
export const JEMMALYN_PORTRAIT = "/brand/jemmalyn-hewlett.jpg";
export const YCN_HERO_VIDEO = "/brand/ycn-hero.mp4";

export const YCN_SOCIAL = {
  facebook: "https://www.facebook.com/share/1HcaWrojbk/?mibextid=wwXIfr",
  instagram: "https://www.instagram.com/yourchannelnetwork/",
};

// Sample public video for Phase 1 demo player only
export const DEMO_VIDEO_URL = "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4";

export const FOUNDERS = [
  {
    name: "Jemmalyn Hewlett",
    role: "Founder",
    bio: "Founder of Your Channel Network. Visionary behind a streaming platform built to entertain, inspire, and empower — creating space for stories, creators, and communities to be seen and heard.",
  },
  {
    name: "Ashley Marie Lewis",
    role: "Co-Founder",
    bio: "Co-Founder of Your Channel Network. Championing culture-forward storytelling, independent creators, and a next-generation streaming experience.",
  },
];

export const AWARDS_INFO = {
  name: "First Annual YCN Awards",
  date_display: "May 1, 2027",
  date_iso: "2027-05-01T19:00:00-04:00",
  venue: "Marriott Virginia Beach Oceanfront Resort",
  city: "Virginia Beach, Virginia",
  ticket_price_usd: 125,
  categories: [
    "Best Original Series",
    "Best Film",
    "Best Documentary",
    "Best Podcast",
    "Best Host",
    "Best Independent Creator",
    "Best Comedy Project",
    "Best Music & Entertainment Program",
    "Community Impact Award",
    "Entrepreneurial Excellence Award",
    "Rising Creator Award",
    "Legacy Award",
  ],
};

// Continue-watching mock data (Phase 1 UI only — real progress tracking is Phase 2)
export const CONTINUE_WATCHING = [
  { title_id: "t-poolside", label: "S1 E4 · 22 min left", progress: 0.6 },
  { title_id: "t-comeup", label: "S1 E4 · 23 min left", progress: 0.55 },
  { title_id: "t-family", label: "S2 E6 · 15 min left", progress: 0.7 },
  { title_id: "t-city", label: "S1 E3 · 32 min left", progress: 0.35 },
];
